import * as React from 'react';
const LogoAccessNoBackground = (props) => (
	<svg xmlns='http://www.w3.org/2000/svg' width='92' height='96' viewBox='0 0 92 96' fill='none' {...props}>
		<rect x='0.0910645' y='0.800293' width='91.6787' height='20.7001' rx='7.43618' fill='#001F97' />
		<rect x='63.0151' y='25.6362' width='28.7812' height='20.7001' rx='7.43618' fill='#001F97' />
		<rect x='33.8545' y='50.4722' width='57.8432' height='20.7001' rx='7.43618' fill='#001F97' />
		<rect x='0.0908203' y='75.3086' width='91.6787' height='20.7001' rx='7.43618' fill='#001F97' />
	</svg>
);
export default LogoAccessNoBackground;
